import { Popover } from "antd";

export const ElectronicsTabV2 = ({
  filterContent,
  open,
  onOpenChange,
  hasActiveFilters,
  amazonSavingamount,
  amazonSavingPercentage
}) => {
  return (
    <div className="flex items-center gap-3 w-full mb-5">

      {/* Best Value Banner */}
     {(amazonSavingamount > 0 && amazonSavingPercentage >= 20)  &&  <div
        className="
          flex flex-1 items-center gap-2
          px-2 py-3
          rounded-xl
          bg-[#4FD1C5]
          text-black
          shadow-[0_2px_8px_rgba(0,0,0,0.12)]
          min-w-0
        "
      >
        <span className="text-[12px] font-semibold break-words">
         💰 ${amazonSavingamount} saved vs Amazon's first picks
        </span>
      </div>}

      {/* Filter Button */}
      <Popover
        content={filterContent}
        trigger="click"
        placement="bottomRight"
        open={open}
        onOpenChange={onOpenChange}
      >
        <button
          className="
            relative shrink-0
            flex items-center gap-1
            px-4 py-3
            rounded-xl
            bg-black text-white
            text-[12px] font-medium
            hover:bg-gray-800
          "
        >
          {hasActiveFilters && (
            <span className="absolute top-2 right-2 w-2.5 h-2.5 bg-red-500 rounded-full ring-2 ring-white" />
          )}
          <span>Filter</span>
          <svg
            viewBox="0 0 24 24"
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
          </svg>
        </button>
      </Popover>
    </div>
  );
};
